import { SITE_ORIGIN } from './siteConfig';
import { localAreaAggregateRating } from './localAreaPageSeo';

export const ORGANIZATION_SCHEMA_ID = `${SITE_ORIGIN}/#organization`;
export const WEBSITE_SCHEMA_ID = `${SITE_ORIGIN}/#website`;

export function organizationSchemaNode() {
  return {
    '@type': 'Organization',
    '@id': ORGANIZATION_SCHEMA_ID,
    name: 'WebCodeCraft',
    url: SITE_ORIGIN
  };
}

export function webSiteSchemaNode() {
  return {
    '@type': 'WebSite',
    '@id': WEBSITE_SCHEMA_ID,
    url: SITE_ORIGIN,
    name: 'WebCodeCraft',
    publisher: { '@id': ORGANIZATION_SCHEMA_ID },
    inLanguage: 'en-GB'
  };
}

export function organizationWithReviewsNode() {
  return {
    ...organizationSchemaNode(),
    aggregateRating: localAreaAggregateRating(`${SITE_ORIGIN}/#organizationAggregateRating`)
  };
}

export function homePageSchemaJsonLd() {
  return JSON.stringify({
    '@context': 'https://schema.org',
    '@graph': [organizationWithReviewsNode(), webSiteSchemaNode()]
  });
}
